var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaStationeryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-stationery-icon_svg__a",
    d: "M0 0h65.483v65.484H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.517)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-stationery-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-stationery-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.484 32.742c0 18.082-14.66 32.742-32.742 32.742C14.659 65.484 0 50.824 0 32.742 0 14.659 14.66 0 32.742 0c18.083 0 32.742 14.66 32.742 32.742",
    fill: "#F8D7CC",
    mask: "url(#ea-stationery-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M10.162 10.161L1.13 19.194V68.87h41.774v-58.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    d: "M1.13 20.323h10.16V10.16h-1.128L1.13 19.194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.903 70H1.13A1.128 1.128 0 010 68.871V19.194c0-.3.119-.588.33-.799l9.033-9.032c.211-.212.498-.33.798-.33h32.742c.625 0 1.13.504 1.13 1.128v21.452a1.128 1.128 0 11-2.259 0V11.29H10.63l-8.37 8.371v48.08h39.515V55.324a1.128 1.128 0 112.258 0V68.87c0 .624-.504 1.129-1.129 1.129",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.29 21.452H5.645a1.128 1.128 0 110-2.258h4.516v-4.517a1.128 1.128 0 112.258 0v5.646c0 .624-.504 1.129-1.129 1.129",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.56 31.837l-27.528 27.53-6.958 1.39 1.393-6.957 27.528-27.53a1.392 1.392 0 011.968 0l3.598 3.599a1.392 1.392 0 010 1.968",
    fill: "#E74A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.506 54.357l-.993 4.962 4.962-.993L59.763 31.04a.264.264 0 000-.372l-3.598-3.598a.264.264 0 00-.372 0L28.506 54.357zm-2.431 7.53a1.13 1.13 0 01-1.108-1.351l1.393-6.957c.044-.22.15-.42.308-.577l27.529-27.53a2.523 2.523 0 013.564 0l3.599 3.599a2.524 2.524 0 010 3.564l-27.53 27.53a1.14 1.14 0 01-.577.308l-6.957 1.39a1.132 1.132 0 01-.221.023z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M56.572 35.826l-5.566-5.566 1.596-1.597 5.566 5.566z"
  }))));
}
export default SvgEaStationeryIcon;